import { call, put, select } from 'redux-saga/effects';

import {
  createModelAttachmentRequest,
  deleteModelAttachmentRequest,
  updateModelAttachmentRequest,
} from '../requests';
import { pathSelector } from '../../../selectors';
import {
  createModelAttachment,
  deleteModelAttachment,
  updateModelAttachment,
} from '../../../actions';
import { createLocalId } from '../../../utils/local-id';

export function* createAttachmentModelService(modelId, data) {
  const localId = yield call(createLocalId);

  yield put(
    createModelAttachment({
      modelId,
      id: localId,
      name: data.file.name,
    }),
  );
  yield call(createModelAttachmentRequest, modelId, localId, data);
}

export function* createAttachmentInCurrentModelService(data) {
  const { modelId } = yield select(pathSelector);

  yield call(createAttachmentModelService, modelId, data);
}

export function* updateAttachmentModelService(id, data) {
  yield put(updateModelAttachment(id, data));
  yield call(updateModelAttachmentRequest, id, data);
}

export function* deleteAttachmentModelService(id) {
  yield put(deleteModelAttachment(id));
  yield call(deleteModelAttachmentRequest, id);
}
